// {
//	codeGroup:'1001',
//	codeList:[{
//		code:'r_dy',
//		name:getLanguageStr("word632+word241","读取电压"),
//		ipt:{//输入规则
//			type:"select", //select input datetime date time,
//			select:[{code:'01',name:'01'},{code:'02',name:"02"}],
//			input:{
//				unit:'',
//				placeholder:'',
//				rule:'',//正则校验输入框数据
//				inputTips:'',//输入提示
//			},
//			date:{}
//		},
//		analysis:[{//解析规则
//			name:getLanguageStr("word241","电压"),
//			valTurn:function(r){return r},
//			unit:''
//		}]
//	},{
//		code:'s_kgj',
//		name:getLanguageStr("cmd16+control6","设置开关机"),
//		ipt:[{//输入规则
//			type:"hm",
//			name:"入参",
//			value:'',
//			valueH:'00',
//			valueM:'00',
//			valTurn:functionList.datetimeFormat,
//			ext:'',
//		}],
//		analysis:[{name:getLanguageStr("control6","开关机"),valTurn:functionList.originReturn,unit:'V'}]
//	},{
//		code:'r_nbqgb',
//		name:getLanguageStr("cmd16+control6","设置开关机"),
//		ipt:[{//输入规则
//			type:"datehms",
//			name:"入参",
//			value:'',
//			valueH:'00',
//			valueM:'00',
//			valueS:'00',
//			valTurn:functionList.datetimeFormat,
//			ext:''
//		}],
//		analysis:[{name:getLanguageStr("control6","开关机"),valTurn:functionList.originReturn,unit:'V'}]
//	},{
//		code:'s_nbqgb',
//		name:getLanguageStr("cmd16+control6","设置开关机"),
//		ipt:[{//输入规则
//			type:"date",
//			name:"入参",
//			value:'',
//			valTurn:functionList.datetimeFormat,
//			ext:''
//		}],
//		analysis:[{name:getLanguageStr("control6","开关机"),valTurn:functionList.originReturn,unit:'V'}]
//	}]
// }

import * as lib from "@/util/lib";
import specialCheckFn from "@/util/rule.js";
import { apiGetDeviceConfigOption } from "@/api/device/order.js";

// import cg1001 from "@/util/orderConfig/1001";
// import cg1002 from "@/util/orderConfig/1002";
// import cg1003 from "@/util/orderConfig/1003";
// import cg1004 from "@/util/orderConfig/1004";
// import cg1005 from "@/util/orderConfig/1005";
// import cg1013 from "@/util/orderConfig/1013";

/**
 * 日期格式化
 * @param {Object} fmt
 */
Date.prototype.Format = function(fmt) {
	var o = {
		"M+": this.getMonth() + 1, // 月份
		"d+": this.getDate(), // 日
		"h+": this.getHours(), // 小时
		"m+": this.getMinutes(), // 分
		"s+": this.getSeconds(), // 秒
		"q+": Math.floor((this.getMonth() + 3) / 3), // 季度
		S: this.getMilliseconds() // 毫秒
	};
	if (/(y+)/.test(fmt))
		fmt = fmt.replace(
			RegExp.$1,
			(this.getFullYear() + "").substr(4 - RegExp.$1.length)
		);
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt))
			fmt = fmt.replace(
				RegExp.$1,
				RegExp.$1.length == 1
					? o[k]
					: ("00" + o[k]).substr(("" + o[k]).length)
			);
	}
	return fmt;
};

/**
 * 根据 code,codeGroup 读取输入框配置
 */
export function getIptConfig(code, codeGroup) {
	try {
		// let cg = orderConfig.filter(item=>{return item.codeGroup == codeGroup})
		// let config = cg[0].codeList.filter(item=>{return item.code == code});
		let cg = deviceConfigOption.rule.option[codeGroup];
		let config = cg.filter(item => {
			return item.code == code;
		});
		return config[0].ipt;
	} catch (e) {
		return {};
	}
}

// 读取指令名称
export function getOrderName(code, codeGroup) {
	try {
		// let cg = orderConfig.filter(item=>{return item.codeGroup == codeGroup});
		// let config = cg[0].codeList.filter(item=>{return item.code == code});console.log(cg)
		let cg = deviceConfigOption.rule.option[codeGroup];
		if (!cg) log.deviceControl.push(`没有${codeGroup}的配置数据`);
		let config = cg.filter(item => {
			return item.code == code;
		});
		return config[0].name; // getLanguage(config[0].name[0])
	} catch (e) {
		return "";
	}
}

/**
 * 根据 code,codeGroup 读取解析配置
 */
export function getAnalysisConfig(code, codeGroup) {
	try {
		// let cg = orderConfig.filter(item=>{return item.codeGroup == codeGroup});
		// let config = cg[0].codeList.filter(item=>{return item.code == code});
		let cg = deviceConfigOption.rule.option[codeGroup];
		let config = cg.filter(item => {
			return item.code == code;
		})[0];
		return config.analysis;
	} catch (e) {
		return [];
	}
}

export function getLanguage(code = "") {
	// 从设备控制配置接口数据中查询国际化，然后再从通用国际化数据中查询
	if (loadContralOption() == true) {
		if ($.type(code) == "array") code = code[0]; // 数组格式取第一个code
		let text = deviceConfigOption.rule.i18n[code]
			? deviceConfigOption.rule.i18n[code][stage.languageId]
			: "";
		if (!text) {
			text = getLanguageStr(code);
		}
		return text;
	} else {
	}
}

export function getLanguageList(list) {
	// 对列表进行国际化
	if (loadContralOption()) {
		let copylist = $.extend(true, [], list);
		$.each(copylist, function(index, val) {
			if (val.name && $.type(val.name) == "array")
				val.name = getLanguage(val.name[0]);
			if (val.text && $.type(val.text) == "array")
				val.text = getLanguage(val.text[0]);
			// copylist[index].name=getLanguage(val.name[0]);
		});
		return copylist;
	}
}

/**
 * 根据 code,codeGroup 根据解析读取结果
 */
// export function getAnalysisValue(code,codeGroup,value){
// 	try{
// 		let cg = orderConfig.filter(item=>{return item.codeGroup == codeGroup})
// 		let config = cg[0].codeList.filter(item=>{return item.code == code});
// 		let r = [];
// 		if(value){
// 			r = value.split(',').map((item,index)=>{
// 				return {
// 					name:config[0].analysis[index].name,
// 					val:config[0].analysis[index].valTurn(item),
// 					unit:config[0].analysis[index].unit,
// 				}
// 			})
// 		}
// 		return r;
// 	}catch(e){
// 		return []
// 	}
// }

/**
 * 解析配置方法
 */
// export const functionList = {
// 	originReturn : function(r){return r.value;},//原值返回
// 	val10:function(r){return Number(r.value)*10},
// 	getVal01:function(val){return Number(val)/10},
// 	val100:function(r){return Number(r.value)*100},
// 	getVal001:function(val){return Number(val)/100},
// 	val1000:function(r){return Number(r.value)*1000},
// 	getVal0001:function(val){return Number(val)/1000},
// 	datetimeFormat:function(r){
// 		let rV =''
// 		if(r.type =='date') {
// 			let d = r.value.Format('yyyy-mm-dd');
// 			rV = d.replace(/\-/g,'');
// 		} else if(r.type=='hm') {
// 			rV = r.valueH + r.valueM;
// 		} else if(r.type =='hms'){
// 			rV = r.valueH + r.valueM + r.valueS;
// 		} else if(r.type =='datehms') {
// 			let d = r.value.Format('yyyy-mm-dd');
// 			rV = d + r.valueH + r.valueM + r.valueS;
// 		} else if(r.type =='datehm'){
// 			rV = d + r.valueH + r.valueM;
// 		}
// 		return rV;
// 	}
// }

export function analyFunction(result) {
	let name = "";
	let value = "";
	let orderName = "";
	let values = [];
	let orderType = null;
	if (result.operationType == 3) {
		// 自定义指令的解析
		orderName = result.content;
		value = result.analysisResult;
	} else if (result.groupCode) {
		let iptP = result.extendWeb
			? JSON.parse(lib.stringFormatForJson(result.extendWeb)).inputParam
			: [];
		let codeGroup = result.groupCode.split(",")[0];
		let code = result.groupCode.split(",")[1];
		let analyConfig = getAnalysisConfig(code, codeGroup);
		// let batchOption = {};
		if (result.operationType == 1) {
			// 1：读取 2：设置 3：自定义
			orderName = getLanguage(getOrderName(code, codeGroup)[0]);
			name = getLanguageStr("device235", "读取结果");
			orderType = getLanguageStr("plant_detail373", "读取");
			let aResult = result.analysisResult;
			let analysisResult;
			if (result.analysisResult == null) {
				value = "--";
			} else {
				try {
					// 多参数
					let analysis = JSON.parse(aResult);
					if (Object.keys(analysis).length > 0) {
						analysisResult = _.map(analysis, (item, index) => ({
							sk: index,
							value: item
						}));
					} else {
						analysisResult = (aResult || "").split(",");
					}
				} catch (error) {
					// 单参数
					analysisResult = (aResult || "").split(",");
				}
				for (let i = 0; i < analysisResult.length; i++) {
					let configInfo;
					if (analysisResult[i].sk) {
						configInfo = _.find(
							analyConfig,
							e => analysisResult[i].sk === e.sk
						);
					} else {
						configInfo = analyConfig[i];
					}
					if (configInfo.type == "input") {
						// && configInfo.valTurn
						// configInfo.name + ":" +
						// value +=configInfo.valTurn(analysisResult[i]||getLanguageStr("(+word116+)","(无)")) +(configInfo.unit||"");
						// value +=configInfo.valTurn(analysisResult[i]||"") +(configInfo.unit||"");	//无返回结果的value保持空
						// let unit = configInfo.unit && $.type(configInfo.unit) == "array" ? getLanguage(configInfo.unit[0]) : configInfo.unit || "";
						if (configInfo.fn) {
							// 启用特殊规则处理
							value += specialCheckFn[configInfo.fn](
								analysisResult[i]
							);
							if (analysisResult[i].sk) {
								values.push({
									value: specialCheckFn[configInfo.fn](
										analysisResult[i]
									),
									configInfo
								});
							}
						} else {
							let unit =
								configInfo.unit &&
								$.type(configInfo.unit) == "array"
									? getLanguage(configInfo.unit[0])
									: configInfo.unit || "";
							if (analysisResult[i].sk) {
								let valueI18n = analysisResult[i].value;
								if (configInfo.valueI18n && analysisResult[i]) {
									valueI18n = getLanguage(
										configInfo.valueI18n[
											analysisResult[i].value
										]
									);
								}
								values.push({
									value: analysisResult[i].value
										? valueI18n + " " + unit
										: "",
									configInfo
								});
							} else {
								let valueI18n = analysisResult[i];
								if (
									configInfo.valueI18n &&
									analysisResult[i] &&
									configInfo.valueI18n[analysisResult[i]]
								) {
									valueI18n = getLanguage(
										configInfo.valueI18n[analysisResult[i]]
									);
								}
								value += valueI18n + " " + unit;
							}
						}
						// value += getLanguage(analysisResult[i] || "") + " " + unit;
					} else if (configInfo.type == "select") {
						if (iptP.length && iptP[i] && iptP[i].optionEx) {
							// 特殊规则处理
							configInfo.list = lib.objTool(
								deviceConfigOption.rule.optionEx[codeGroup][
									iptP[i].optionEx.dataKey
								][iptP[i].optionEx.target],
								"returnSelectData",
								{
									fromTextKey: "targetValue",
									fromValueKey: "strValue",
									toTextKey: "text",
									toValueKey: "value"
								}
							);
						}
						value = analysisResult[i]; // value 设置默认值
						configInfo.list.map(item => {
							if (
								analysisResult[i].value === item.value ||
								analysisResult[i] === item.value
							) {
								let val;
								// 匹配到列表数据
								if ($.type(item.text) == "string")
									val = getLanguage(item.text);
								// 有些数据来源是已经翻译好的
								else val = getLanguage(item.text[0]);
								value = val;
								if (analysisResult[i].sk) {
									values.push({
										value: val,
										configInfo
									});
								}
							}
							// if (analysisResult[i] == "") {
							// 	value = "--";
							// } else if (analysisResult[i] === item.value) {
							// 	let val;
							// 	//匹配到列表数据
							// 	if ($.type(item.text) == "string") val = getLanguage(item.text);
							// 	//有些数据来源是已经翻译好的
							// 	else val = getLanguage(item.text[0]);
							// 	value = val;
							// 	if (analysisResult[i].sk) {
							// 		values.push({
							// 			value: val,
							// 			configInfo,
							// 		});
							// 	}
							// } else if (!value) value = analysisResult[i]; //找不到就展示值
						});
						if (analysisResult[i]) {
							// 显示默认值
							if (
								value == analysisResult[i] &&
								configInfo.default
							) {
								value = getLanguage(configInfo.default);
							}
						} else {
							value = "--";
						}
					} else if (configInfo.type == "time") {
						let val =
							analysisResult[i].substr(0, 4) +
							"/" +
							analysisResult[i].substr(4, 2) +
							"/" +
							analysisResult[i].substr(6, 2) +
							" " +
							analysisResult[i].substr(8, 2) +
							":" +
							analysisResult[i].substr(10, 2) +
							":" +
							analysisResult[i].substr(12, 2);
						value = val;
						if (analysisResult[i].sk) {
							values.push({
								value: val,
								configInfo
							});
						}
					} else if (configInfo.type == "hm") {
						let val =
							analysisResult[i].substr(0, 2) +
							":" +
							analysisResult[i].substr(2, 4);
						value = val;
					}
				}
			}
		} else if (result.operationType == 4) {
			$.each(
				deviceConfigOption.rule.optionClass[codeGroup],
				(index, cmd) => {
					// 从总配置里抽出对应指令进行索引
					if (cmd.codeR == code) {
						// batchOption[cmd.codeR]=cmd;
						orderName = getLanguage(cmd.name[0]);
						return false;
					}
				}
			);
		} else if (result.operationType == 5) {
			$.each(
				deviceConfigOption.rule.optionClass[codeGroup],
				(index, cmd) => {
					// 从总配置里抽出对应指令进行索引
					if (cmd.codeS == code) {
						// batchOption[cmd.codeR]=cmd;
						orderName = getLanguage(cmd.name[0]);
						return false;
					}
				}
			);
		} else {
			// 设置
			orderName = getLanguage(getOrderName(code, codeGroup)[0]);
			name = getLanguageStr("plant_detail141", "输入项");
			orderType = getLanguageStr("user13", "设置");
			let sendAction = result.groupCode.split(",")[1].split("-");
			if (
				sendAction.length &&
				sendAction[sendAction.length - 1].includes("r_") &&
				result.analysisResult == null
			) {
				// 读取类处理null值
				value = "--";
			} else {
				if (analyConfig.length && result.extendWeb) {
					// 仅对支持的指令进行处理
					iptP.map((v, idx) => {
						let configInfo;
						if (iptP[idx].sk) {
							configInfo = _.find(
								analyConfig,
								e => iptP[idx].sk === e.sk
							);
						} else {
							configInfo = analyConfig[idx];
						}
						if (configInfo.type == "input") {
							// && configInfo.valTurn
							let before =
								iptP.length > 1
									? getLanguage(configInfo.name[0]) + ":"
									: "";
							// value +=before+ (configInfo.valTurn(v.oValue)||"--") +(configInfo.unit||"");
							let unit =
								configInfo.unit &&
								$.type(configInfo.unit) == "array"
									? getLanguage(configInfo.unit[0])
									: configInfo.unit || "";
							let showValue = v.value || v.oValue;
							if (
								showValue == undefined ||
								showValue === "" ||
								showValue == null
							)
								showValue = "--";
							if (configInfo.fn) {
								// 启用特殊规则处理
								value += specialCheckFn[configInfo.fn](v.value);
							} else {
								value += before + showValue + " " + unit;
							}
							if (v.sk) {
								values.push({
									value: showValue + " " + unit,
									configInfo
								});
							}
						} else if (configInfo.type == "select") {
							if (iptP[idx].optionEx) {
								// 特殊规则处理
								configInfo.list = lib.objTool(
									deviceConfigOption.rule.optionEx[codeGroup][
										iptP[idx].optionEx.dataKey
									][iptP[idx].optionEx.target],
									"returnSelectData",
									{
										fromTextKey: "targetValue",
										fromValueKey: "strValue",
										toTextKey: "text",
										toValueKey: "value"
									}
								);
							}
							configInfo.list.map(item => {
								if (v.oValue == item.value) {
									value = getLanguage(item.text);
									if (v.sk) {
										values.push({
											value: getLanguage(item.text),
											configInfo
										});
									}
								}

								// if(v.oValue == item.value) value =item.text;
							});
						} else if (configInfo.type == "time") {
							value = v.oValue;
							if (v.sk) {
								values.push({
									value: v.oValue,
									configInfo
								});
							}
						} else if (configInfo.type == "hm") {
							value = v.oValue;
						}
					});
				}
			}
		}
	}
	let r = {
		name: name,
		// value:value||"("+getLanguageStr("word116","无")+")",
		value: value || "",
		orderName: orderName,
		values
	};

	orderType && (r.type = orderType);
	return r;
}

export function loadContralOption(fn) {
	if (window.deviceConfigOption && !window.deviceConfigOption.api) {
		// 有api代表之前的还没走完
		if (
			new Date().getTime() - deviceConfigOption.loadTime >
			1000 * 60 * 60 * 2
		) {
			// 更新控制配置的频率
			deviceConfigOption.loadTime = new Date().getTime();
			apiGetDeviceConfigOption();
		}
		if (fn) fn();
		return true;
		// return new Promise(resolve=>{
		// 	resolve("");
		// });
	} else {
		apiGetDeviceConfigOption().then(() => {
			if (fn) fn();
		});
		// setTimeout(()=>{
		// },0);
		return false;
	}
}
// loadContralOption();

// export const orderConfig=[cg1001,cg1002,cg1003,cg1004,cg1005,cg1013];



// WEBPACK FOOTER //
// ./src/util/deviceOrderConfig.js